var debug = require('debug');

var memoizer = require('lru-memoizer');

function cacheWrapper(client, _ref) {
  var _ref$cacheMaxEntries = _ref.cacheMaxEntries,
      cacheMaxEntries = _ref$cacheMaxEntries === void 0 ? 5 : _ref$cacheMaxEntries,
      _ref$cacheMaxAge = _ref.cacheMaxAge,
      cacheMaxAge = _ref$cacheMaxAge === void 0 ? 600000 : _ref$cacheMaxAge;
  var logger = debug('jwks');
  logger("Configured caching of signing keys. Max: ".concat(cacheMaxEntries, " / Age: ").concat(cacheMaxAge));
  return memoizer.sync({
    hash: function hash(kid) {
      return kid;
    },
    load: client.getSigningKey.bind(client),
    maxAge: cacheMaxAge,
    max: cacheMaxEntries
  });
}

module.exports.default = cacheWrapper;